import React from "react";
import s from "./style.module.scss";
import Coins from "./icons/Coins";

interface BonusesProps {
  count: number;
}

const Bonuses: React.FC<BonusesProps> = ({ count }) => {
  return (
    <div className={s.bonuses}>
      <Coins />
      <span>{count}</span>
    </div>
  );
};

export default Bonuses;
